/* eslint-disable prettier/prettier */
import React, { useContext } from 'react'
import moment from 'moment'
import { EMOJIS } from './utils'
import styles from '../components/toolbar/styles'
import { VideoCallContext } from '../../../hooks/videoCallContext'

export default function useSignal({ room, roomId }) {
  const [listOfMessages, setListOfMessages] = React.useState([])
  const classes = styles()
  const { setRoomState, getRoomState } = useContext(VideoCallContext)

  const sendSignal = React.useCallback(
    (data, type) => {
      if (room) {
        room.signal({ type, data }).catch(e => e)
      }
    },
    [room]
  )

  const signalListener = ({ data, isSentByMe, from }) => {
    const date = moment(new Date().getTime()).format('HH:mm')
    addMessageToList(data, isSentByMe, from, date)
  }

  const removeEmoji = (node, element) => {
    document.getElementById(element).removeChild(node)
  }

  const emojiHandler = React.useCallback(({ data, isSentByMe, from }) => {
    const elementToInsertEmoji = isSentByMe
      ? 'MP_camera_publisher_default_controls' // Elemento do emissor
      : from.camera.id // Elemento do receptor
    const node = document.createElement('div')
    
    // Adiciona o emoji ao nó
    node.appendChild(document.createTextNode(EMOJIS[data]))
    node.classList.add(classes.reactionContainer)
    
    // Insere o nó no elemento correspondente
    const parentElement = document.getElementById(elementToInsertEmoji)
    parentElement?.appendChild(node)
  
    // Remove o emoji ao final da animação
    node.addEventListener('animationend', () => {
      parentElement?.removeChild(node)
    })
  }, [])

  const addMessageToList =(data, isSentByMe, from, date) => {
    console.log(getRoomState(roomId).listOfMessages)
    console.log(getRoomState(roomId).listOfMessages.length)
    setRoomState(roomId, {
    listOfMessages: [
      ...getRoomState(roomId).listOfMessages,
      { data, isSentByMe, from, date }
    ] })
  }

  React.useEffect(() => {
    if (room) {
      room.on('signal:text', signalListener)
      room.on('signal:emoji', emojiHandler)
    }
    return function cleanup() {
      if (room) {
        room.off('signal:text', signalListener)
        room.off('signal:emoji', emojiHandler)
      }
    }
  }, [room, signalListener, emojiHandler])

  return {
    sendSignal,
    listOfMessages: getRoomState(roomId)?.listOfMessages || []
  }
}